import React, { ComponentProps } from 'react';
import { environment } from '~/config/public';
import { useTranslation } from '~/Locale';

interface Props extends ComponentProps<'a'> {
  url: string;
  closeAt: string;
  object: string;
  children: React.ReactNode;
}

const ShareEmail = ({ url, object, closeAt, children, ...props }: Props) => {
  const { t } = useTranslation();
  const body = t(
    'AUCTION_EMAIL_BODY %1$s %2$s %3$s',
    object,
    closeAt,
    `${environment.baseUrl}${url}`
  );
  const subject = t('AUCTION_EMAIL_SUBJECT');

  const mailUrl = `mailto:?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;

  return (
    <a {...props} href={mailUrl} rel="noopener noreferrer" target="_blank">
      {children}
    </a>
  );
};

export default ShareEmail;
